import { useRef, useState } from "react";
import { Loader2, ScanLine } from "lucide-react";
import { toast } from "sonner";
import { Button } from "./ui/button";
import api, { formatApiError } from "../api";

export const ScanSlipButton = ({ onResult, tripId, className = "", testId = "scan-slip-btn" }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const onFile = async (e) => {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (!f) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", f);
      if (tripId) fd.append("trip_id", tripId);
      const { data } = await api.post("/scan-slip", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onResult(data);
      if (data.scan_tersisa != null && data.scan_tersisa <= 3) {
        toast.info(`Sisa scan AI hari ini: ${data.scan_tersisa}`, { duration: 5000 });
      }
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Gagal memindai slip");
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <input ref={ref} type="file" accept="image/*" capture="environment" className="hidden"
        onChange={onFile} data-testid={`${testId}-input`} />
      <Button type="button" variant="outline" data-testid={testId} disabled={busy}
        onClick={() => ref.current?.click()}
        className={`text-emerald-700 border-emerald-300 hover:bg-emerald-50 transition-colors duration-200 ${className}`}>
        {busy ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <ScanLine className="w-4 h-4 mr-2" />}
        {busy ? "Membaca slip..." : "Scan Slip"}
      </Button>
    </>
  );
};
